import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TranslationService from '../../../../core/services/TranslationService';
import { Conversation } from '../types/Conversation';
import { useAppContext } from '../../../../AppContext';

type Props = {
  currentConversation?: Conversation;
};

const CaseDetails = (props: Props) => {
  const context = useAppContext();

  const getThemeBgColor = () => {
    const messageModule = context.styles['module:messages'];
    const brandColors = context.styles['general:colors']?.brand;
    if (messageModule?.backgroundColor) return messageModule.backgroundColor;
    if (brandColors) return brandColors.split(',')[0];
    return '#003f5f';
  };

  const getThemeTextColor = () => {
    const messageModule = context.styles['module:messages'];
    if (messageModule?.textColor) return messageModule.textColor;
    return '#ffffff';
  };

  const bgColor = getThemeBgColor();
  const textColor = getThemeTextColor();

  const fields = [
    { label: 'CaseNr', value: props.currentConversation?.caseDetails.caseNumber },
    { label: 'RegDate', value: props.currentConversation?.caseDetails.regDate },
    { label: 'CloseDate', value: props.currentConversation?.caseDetails.closeDate },
    { label: 'CreditorName', value: props.currentConversation?.caseDetails.creditorName },
    { label: 'ReferenceNo', value: props.currentConversation?.caseDetails.referenceNumber },
  ];

  return (
    <Box sx={{ bgcolor: bgColor, color: textColor, px: 2, py: 1.5, flexShrink: 0 }}>
      <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 'bold', mb: 1 }}>
        {TranslationService.translate('CaseDetails')}
      </Typography>
      {props.currentConversation && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { xs: 1, sm: 2 } }}>
          {fields.map((field) => (
            <Box key={field.label} sx={{ minWidth: 100 }}>
              <Typography
                variant="caption"
                sx={{ textTransform: 'uppercase', opacity: 0.85, display: 'block', lineHeight: 1.3 }}
              >
                {TranslationService.translate(field.label)}
              </Typography>
              <Typography variant="body2" noWrap sx={{ fontWeight: 'bold' }}>
                {field.value || '\u00A0'}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default CaseDetails;